import React, { PropsWithChildren, memo, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useSessionStorage } from '../sessionStorage';

export interface LandingConfig {
  audience: 'youth' | 'adult';
}

function createLadingConfig(): LandingConfig {
  const [sessionValue, setSessionValue] = useSessionStorage('ml.landingConfig', { audience: 'adult' });

  let value = sessionValue;

  const query = queryString.parse(useLocation().search);
  const audience = Array.isArray(query.audience) ? query.audience[0] : (query.audience as string);
  if (['youth', 'adult'].indexOf(audience) >= 0 && sessionValue.audience != audience) {
    value = { ...sessionValue, audience };
    setSessionValue(value);
  }

  console.log('createLadingConfig', value);
  return value;
}

const LandingContext = React.createContext<LandingConfig>(null);

export const LandingConfig = memo(({ children }: PropsWithChildren<object>) => {
  const landingConfig = createLadingConfig();
  return <LandingContext.Provider value={landingConfig}>{children}</LandingContext.Provider>;
});

export const useLandingConfig = () => useContext(LandingContext);
